<ng-template cxOutletRef="ProductDetailsPageTemplate" [cxOutletPos]="outletPosition">
  <div id="productSchemaContent" [innerHTML]="schemaHtml$ | async"></div>
</ng-template>
